export default __webpack_public_path__ + "static/media/aDai.0206341f.svg";